module.exports = __webpack_public_path__ + "static/media/bipedge-white.4998f335.jpg";